var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
var FavoriteOutline16 = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'currentcolor' : _b, _c = _a.height, height = _c === void 0 ? '16px' : _c, _d = _a.width, width = _d === void 0 ? '16px' : _d, rest = __rest(_a, ["color", "height", "width"]);
    var svgStyle = __assign({ "position": "absolute", "top": "0", "right": "0", "bottom": "0", "left": "0", "width": "100%", "height": "100%" }, { fill: color });
    return (React.createElement("div", __assign({ style: __assign({ "position": "relative" }, { height: height, width: width }) }, rest),
        React.createElement("svg", { viewBox: "0 0 16 16", style: svgStyle },
            React.createElement("path", { d: "M8.56 3.013c.76-.862 1.685-1.388 2.772-1.388 1.087 0 1.88.425 2.397 1.128.309.42.459.838.491 1.067.024.063.054.169.082.316.5 2.56-.998 5.988-6.076 9.82L8 14.128l-.226-.17c-5.078-3.833-6.576-7.261-6.076-9.821.028-.147.058-.253.064-.248.05-.297.2-.715.51-1.135.516-.703 1.31-1.128 2.396-1.128 1.087 0 2.011.526 2.773 1.389.21.239.397.49.559.744a5.92 5.92 0 01.56-.745zm4.504 4.35c.553-1.267.654-2.308.502-3.084a2.525 2.525 0 00-.067-.265 2.063 2.063 0 00-.374-.816c-.38-.517-.952-.823-1.793-.823-.842 0-1.579.42-2.21 1.135a5.335 5.335 0 00-.78 1.17L8 5.45l-.342-.771a5.34 5.34 0 00-.78-1.17c-.631-.715-1.369-1.135-2.21-1.135s-1.413.306-1.793.823a2.211 2.211 0 00-.392.883c-.01.026-.029.092-.05.198-.15.776-.05 1.817.503 3.084C3.737 9.198 5.36 11.155 8 13.186c2.64-2.031 4.263-3.988 5.064-5.823z" }))));
};
FavoriteOutline16.displayName = 'FavoriteOutline16';
export default FavoriteOutline16;
//# sourceMappingURL=favorite-outline-16.js.map